module.exports = "/next-static/_next/static/images/hero_image_small-f2f9ff598d89c4f5cc01a06b34e29f43.png";